import SystemModalClosingCrossIcon from "../../icons/SystemModalClosingCrossIcon";

export default function GameDetailedScreenHeader({ game,
                                                   handleClose }) {
    // Used in GameDetailedScreen to display Term word
    // in header

    // BUILD
    return (
        <div className="w-full flex justify-start items-start space-x-[12px] pl-[16px] pr-[12px] pt-[8px] pb-[12px] border-b border-greyLight5 bg-gradient-to-br from-backgroundLight3 to-backgroundLight1">
            <div className={"w-full flex flex-col justify-start items-start space-y-[6px]"}>
                <div className={"w-full flex justify-between items-start"}>
                    <span className={"font-medium text-[16px] text-white"}>
                        {game.title ?? "Inconnu"}
                    </span>
                    <SystemModalClosingCrossIcon onIconPress={handleClose} />
                </div>
                <span className={"font-normal text-[14px] text-greyLight9"}>
                    {game.description ?? "Inconnu"}
                </span>
            </div>
        </div>
    );
}